export default __webpack_public_path__ + "static/media/H4008.91f66423.mp3";